import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Config } from '../../../../core/Config';
import { environment } from '../../../../../environments/environment';
import { AllTerminals, FIlteredTerminal, UnsuccessfulTerminals } from './models/terminals-models';

const BASE_URL = environment.BASE_URL;

@Injectable({
  providedIn: 'root'
})
export class TerminalService {
  constructor(
    private httpClient: HttpClient,
    private config: Config
  ) {}

  getTerminals(pageIndex, pageSize, searchParams?): Observable<AllTerminals> {
    let params = new HttpParams();

    if (pageIndex) {
      params = params.append("pageIndex", pageIndex);
    }
    if (pageSize) {
      params = params.append("pageSize", pageSize);
    }
    if (searchParams?.merchantId) {
      params = params.append("merchantId", searchParams.merchantId);
    }

    return this.httpClient
      .get<AllTerminals>(BASE_URL + this.config.getTerminals, { params })
      .pipe(
        map((terminals) => {
          return terminals;
        })
      );
  }

  getTerminalByTerminalIdOrMerchantId(searchParams:  Partial<{merchantId: string;terminalId: string;}>): Observable<FIlteredTerminal> {
    let params = new HttpParams();
    if (searchParams.merchantId) {
      params = params.append("merchantId", searchParams.merchantId)
    } 
    if (searchParams.terminalId) {
      params = params.append("terminalId", searchParams.terminalId);
    } 
    
    return this.httpClient.get<FIlteredTerminal>(BASE_URL + this.config.getTerminalsByTerminalIdOrMerchantId, { params })
      .pipe(
        map((terminal) => {
          return terminal;
        })
      )
  }

  createTerminal(terminalDetails) {
    return this.httpClient.post(BASE_URL + this.config.createTerminal, terminalDetails);
  }
  
  updateTerminal(terminalDetails) {
    return this.httpClient.patch(BASE_URL + this.config.updateTerminal, terminalDetails);
  }

  deleteTerminal(code: string) {
    return this.httpClient.delete(BASE_URL + this.config.deleteTerminal + '/' + code, {});
  }


  bulkUpload(file, clientId?: number) {
    let params = new HttpParams();
    if (clientId) {
      params = params.append("clientId", clientId);
    }
    const formData = new FormData();
    formData.append("file", file);
    return this.httpClient.post(BASE_URL + this.config.uploadTerminal, formData, {params})
    .pipe(
      map((unssuccessfulTerminals: UnsuccessfulTerminals) => {
        return unssuccessfulTerminals;
      })
    )
  }

  disableTerminal(tId: string) {
    let params = new HttpParams()
      .append("terminalId", tId);
    return this.httpClient.patch(BASE_URL + this.config.disableTerminal, '/', { params });
  }

  enableTerminal(tId: string) {
    let params = new HttpParams()
      .append("terminalId", tId);
    return this.httpClient.patch(BASE_URL + this.config.enableTerminal, '/', { params });
  }
}

